// // components/modal/CustomModal.tsx
// import { Dialog, Transition } from "@headlessui/react";
// import { Fragment } from "react";

// interface CustomModalProps {
//   isOpen: boolean;
//   closeModal: () => void;
//   title?: string;
//   children: React.ReactNode;
// }

// const CustomModal: React.FC<CustomModalProps> = ({
//   isOpen,
//   closeModal,
//   title,
//   children,
// }) => {
//   return (
//     <Transition appear show={isOpen} as={Fragment}>
//       <Dialog as="div" className="relative z-50" onClose={closeModal}>
//         <Transition.Child
//           as={Fragment}
//           enter="ease-out duration-300"
//           enterFrom="opacity-0"
//           enterTo="opacity-100"
//           leave="ease-in duration-200"
//           leaveFrom="opacity-100"
//           leaveTo="opacity-0"
//         >
//           {/* Updated Background with Blur */}
//           <div className="fixed inset-0 bg-black/30 backdrop-blur-sm transition-opacity" />
//         </Transition.Child>

//         <div className="fixed inset-0 overflow-y-auto flex items-center justify-center p-4">
//           <div
//             className="
//              w-[75%]
//               p-6 transform overflow-hidden rounded-2xl bg-white shadow-xl transition-all
//               max-h-[90vh] flex flex-col
//             "
//           >
//             {/* <Dialog.Title
//               as="h3"
//               className="text-lg font-medium leading-6 text-gray-900"
//             >
//               {title || "Details"}
//             </Dialog.Title> */}
//             <div className="mt-2 overflow-y-auto flex-1">{children}</div>
//             <div className="mt-4 flex justify-end">
//               <button
//                 type="button"
//                 className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
//                 onClick={closeModal}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       </Dialog>
//     </Transition>
//   );
// };

// export default CustomModal;

import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

interface CustomModalProps {
  isOpen: boolean;
  closeModal: () => void;
  title?: string;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "full";
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  closeModal,
  title = "Details",
  children,
  size,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        {/* Background overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
        </Transition.Child>

        {/* Modal container */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-95 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-95 scale-95"
          >
            <Dialog.Panel
              className={`w-full transform overflow-hidden rounded-xl bg-white shadow-lg transition-all ${
                size === "sm"
                  ? "max-w-[50%]"
                  : size === "md"
                  ? "max-w-[75%]"
                  : size === "lg"
                  ? "max-w-[85%]"
                  : size === "xl"
                  ? "max-w-[95%]"
                  : "max-w-[95%]"
              }`}
            >
              {/* Header */}
              <div className="flex justify-between items-center border-b px-6 py-4">
                <Dialog.Title className="text-lg font-semibold text-gray-900">
                  {title}
                </Dialog.Title>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-600 transition"
                >
                  ✕
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-4 max-h-[70vh] flex justify-center overflow-y-auto">
                {children}
              </div>

              {/* Footer */}
              <div className="flex justify-end border-t px-6 py-3 bg-gray-50">
                <button
                  type="button"
                  className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 transition"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CustomModal;
